import {Button, Group, Modal, Stack} from '@mantine/core';
import React from 'react';

export interface AntibodyComponentMigrationPreviewModalProps {
  componentTypeName: string;
  onClose: () => void;
  onApply: () => void;
}

/**
 * Confirmation modal shown before applying a protein component type to an existing schema.
 * Previews the enforced changes the migration will make and lets the user confirm or cancel.
 */
export default function AntibodyComponentMigrationPreviewModal({
  componentTypeName,
  onClose,
  onApply,
}: AntibodyComponentMigrationPreviewModalProps): JSX.Element {
  return (
    <Modal
      title={`Apply ${componentTypeName} protein component type`}
      opened={true}
      onClose={onClose}
      size="lg"
    >
      <Stack spacing="lg">
        <Group position="right">
          <Button variant="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button onClick={onApply}>Apply</Button>
        </Group>
      </Stack>
    </Modal>
  );
}
